import { render, staticRenderFns } from "./PublicReservation.vue?vue&type=template&id=32993340&scoped=true&"
import script from "./PublicReservation.vue?vue&type=script&lang=js&"
export * from "./PublicReservation.vue?vue&type=script&lang=js&"
import style0 from "./PublicReservation.vue?vue&type=style&index=0&id=32993340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32993340",
  null
  
)

export default component.exports